export default __webpack_public_path__ + "static/media/mc.459a8e0c.svg";